import { render, staticRenderFns } from "./CommentPhotoModal.vue?vue&type=template&id=7ab1077e&scoped=true&"
import script from "./CommentPhotoModal.vue?vue&type=script&lang=js&"
export * from "./CommentPhotoModal.vue?vue&type=script&lang=js&"
import style0 from "./CommentPhotoModal.vue?vue&type=style&index=0&id=7ab1077e&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab1077e",
  null
  
)

export default component.exports